<template>
  <div>
    <!-- 상단 제목 -->
    <div class="topbanner" aria-label="로그인 페이지 입니다.">
      <h2 aria-hidden="true">로그인</h2>
    </div>
    <!--// 상단 제목 -->
    <!-- 메인 컨텐츠 영역 -->
    <article class="main_contents">
      <div class="login_wrap">
        <!-- 이름 -->
        <div class="form-group-input">
          <span class="login-form-placeholder" aria-hidden="true">이&nbsp;&nbsp;름 : &nbsp;</span>
          <input type="text" class="login-form-control" ref="user_name" v-model.trim="user_name"
                 value="" role="textbox" aria-label="이름을 입력하는 필드"/>
        </div>
        <!-- 연락처 -->
        <div class="form-group-input">
          <span class="login-form-placeholder" aria-hidden="true">연 락 처 : &nbsp;</span>
          <input type="number" class="login-form-control" ref="user_tel" v-model.trim="user_tel"
                 value="" role="textbox" aria-label="연락처를 입력하는 필드"/>
        </div>
        <!-- 비밀번호 -->
        <div class="form-group-input">
          <span class="login-form-placeholder" aria-hidden="true">비밀번호 : &nbsp;</span>
          <input type="password" class="login-form-control" ref="user_pw" v-model.trim="user_pw"
                 value="" role="textbox" aria-label="비밀번호를 입력하는 필드"/>
        </div>
        <!-- 로그인버튼 및 자동로그인 체크박스 -->
        <div class="form-group">
          <!-- 상태 메시지 영역 -->
          <div class="visually-hidden" ref="statusMessage" aria-live="assertive">{{ statusMessage }}</div>
          <button class="btn_common" @click="login" aria-label="로그인">로그인</button>
          <div class="btn_check">
            <span ref="statusMessage" aria-live="assertive" class="visually-hidden"></span>
            <input id="check_login" type="checkbox" name="auto_login" title="자동로그인"
                   v-model="auto_login" :checked="auto_login"/>
            <label for="check_login"></label><span @click="autoLoginCheck" aria-label="자동 로그인 체크박스">자동로그인</span>
          </div>
        </div>
      </div>
      <p class="msgbox_yellow"
         aria-label="복지콜 신규가입을 원하시거나, 아직 비밀번호를 설정하지 않으신 경우, 1600-4477로 연락주시면 자세한 안내를 받아보실 수 있습니다.">
        복지콜 신규가입을 원하시거나<br/>아직 비밀번호를 설정하지 않으신 경우<br/>1600-4477 로 연락주시면<br/>자세한 안내를 받아보실 수 있습니다.</p>
      <!--p class="msgbox_yellow">서비스준비중입니다.</p-->
    </article>
    <!--// 메인 컨텐츠 영역 -->
  </div>
</template>


<script>
export default {
  data() {
    return {
      user_name: "",
      user_tel: "",
      user_pw: "",
      auto_login: false,
      statusMessage:""
    }
  },
  mounted() {
    this.$store.commit('setMenuNo', {'p_no': 0, 'category_no': 0});
  },
  methods: {
    login() {
      if (this.user_name == "") {
        alert("이름을 입력해주세요.");
        this.$refs.user_name.focus();
        return;
      }

      if (this.user_tel == "") {
        alert("연락처를 입력해주세요.");
        this.$refs.user_tel.focus();
        return;
      }

      if (this.user_pw == "") {
        alert("비밀번호를 입력해주세요.");
        this.$refs.user_pw.focus();
        return;
      }

      var formData = new FormData();
      formData.append("user_name", this.user_name);
      formData.append("user_tel", this.user_tel);
      formData.append("user_pw", this.user_pw);
      formData.append("auto_login", this.auto_login ? 1 : 0);

      this.$http.post('/api/loginCheck.do', formData).then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          this.$store.commit("setSession", {
            user_id: response.data.user_id,
            user_name: response.data.user_name,
            user_tel: response.data.user_tel
          });
          //this.$eventBus.$emit('watchCall');

          // 성공 메시지 업데이트
          this.statusMessage = "로그인이 완료되었습니다.";

          // 메시지가 읽히도록 약간의 대기 시간 후 페이지 이동
          setTimeout(() => {
            if (this.$route.query.return_url) {
              this.$router.push(this.$route.query.return_url);
            } else {
              this.$router.push("/m");
            }
          }, 1500); // 1초 대기

          /*if (this.$route.query.return_url) {
            this.$router.push(this.$route.query.return_url);
          } else {
            this.$router.push("/m");
            //this.callCheck();
          }*/
        } else {
          if (response.data.error_msg && response.data.error_msg.trim() != "") {
            if (response.data.error_msg.trim() == "Not find customer") {
              alert(
                  "복지콜 신규가입을 원하시거나 아직 비밀번호를 설정하지 않으신 경우 02-2092-0000 으로 연락주시면 자세한 안내를 받아보실 수 있습니다.");
            } else if (response.data.error_msg.trim() == "This customer has stopped the service") {
              alert("로그인을 실패하였습니다. 고객센터로 연락 바랍니다.");
            } else {
              alert("로그인을 실패 하였습니다. [" + response.data.error_msg.trim() + "]");
            }
          } else {
            alert("로그인을 실패 하였습니다. [error_code:" + response.data.retval + "]");
          }
        }
      });
    },
    callCheck() {
      this.$http.get('/api/order/progress.do', null, false).then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          if (response.data.callInfo) {
            this.$router.push("/m/order/progress");
            return;
          }
        }

        this.$router.push("/m");
      }).catch(error => {
        this.$router.push("/m");
      });
    },
    autoLoginCheck() {
      this.auto_login = !this.auto_login;
      this.updateAutoLoginStatus();
    },
    updateAutoLoginStatus() {
      // 상태 메시지를 동적으로 업데이트하여 TalkBack이 읽도록 설정
      const status = this.auto_login ? '자동 로그인 활성화됨' : '자동 로그인 비활성화됨';
      this.$refs.statusMessage.textContent = status;
    }
  }
}
</script>


<style>
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue